var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.uploads.length > 0
  ? true
  : false)
    ? _c(
        "div",
        _vm._l(_vm.uploads, function(upload, idx) {
          return _c(
            "div",
            {
              key: upload._id,
              staticClass: "email",
              staticStyle: { margin: "5px", padding: "5px" }
            },
            [
              _c(
                "b",
                { staticStyle: { color: "purple", "font-size": "16px" } },
                [_vm._v("File: " + _vm._s(upload.originalFileName))]
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("On:")]),
              _vm._v(
                " " +
                  _vm._s(new Date(upload.when).toLocaleDateString()) +
                  " " +
                  _vm._s(new Date(upload.when).toLocaleTimeString()) +
                  ",\n\t\t"
              ),
              _c("b", [_vm._v("Total:")]),
              _vm._v(" " + _vm._s(upload.totalCount) + ",\n\t\t"),
              _c("b", [_vm._v("Updated:")]),
              _vm._v(" " + _vm._s(upload.successCount) + ",\n\t\t"),
              _c("b", [_vm._v("Rejected:")]),
              _vm._v(" " + _vm._s(upload.rejectCount) + ",\n\t\t"),
              _c("b", [_vm._v("Deleted:")]),
              _vm._v(" " + _vm._s(upload.deleteCount)),
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggleChanges(idx)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.isChangesVisible(idx)
                          ? "Close Changes"
                          : "Show Changes"
                      ) +
                      "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "expand" } }, [
                upload.fileLog && _vm.isChangesVisible(idx)
                  ? _c(
                      "div",
                      { staticClass: "changes-container" },
                      [
                        _vm.getTotalChanges(idx) > 0
                          ? _c("div", { staticClass: "pagination-info" }, [
                              _c(
                                "span",
                                { staticClass: "pagination-summary" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\tShowing " +
                                      _vm._s(_vm.getDisplayStart(idx)) +
                                      "-" +
                                      _vm._s(_vm.getDisplayEnd(idx)) +
                                      " of " +
                                      _vm._s(_vm.getTotalChanges(idx)) +
                                      " resources\n\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showPagination(idx)
                                ? _c(
                                    "div",
                                    { staticClass: "items-per-page-selector" },
                                    [
                                      _c("label", [_vm._v("Items per page:")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.paginationSettings[idx]
                                                  .itemsPerPage,
                                              expression:
                                                "paginationSettings[idx].itemsPerPage"
                                            }
                                          ],
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.paginationSettings[idx],
                                                  "itemsPerPage",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                              function($event) {
                                                return _vm.handleItemsPerPageChange(
                                                  idx
                                                )
                                              }
                                            ]
                                          }
                                        },
                                        _vm._l(_vm.paginationOptions, function(
                                          option
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: option,
                                              domProps: { value: option }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(option) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.getPaginatedChanges(idx), function(res, i) {
                          return _c(
                            "div",
                            { key: "resource:" + i + ":" + res.fileNumber },
                            [
                              _c("div", [
                                res.success
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "green",
                                          "font-weight": "600"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(res.fileNumber) +
                                            " " +
                                            _vm._s(
                                              res.resourceName
                                                ? res.resourceName
                                                : "Unknown"
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !res.success
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "600"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(res.fileNumber) +
                                            " " +
                                            _vm._s(
                                              res.resourceName
                                                ? res.resourceName
                                                : "Unknown"
                                            ) +
                                            " - (Reason:: " +
                                            _vm._s(res.message) +
                                            ") "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.showPagination(idx)
                          ? _c(
                              "div",
                              { staticClass: "pagination-controls" },
                              [
                                _c("paginate", {
                                  attrs: {
                                    "page-count": _vm.getTotalPages(idx),
                                    "page-range": 3,
                                    "margin-pages": 2,
                                    "click-handler": function(pageNum) {
                                      return _vm.handlePageChange(idx, pageNum)
                                    },
                                    "prev-text": "Prev",
                                    "next-text": "Next",
                                    "container-class": "pagination",
                                    "page-class": "page-item"
                                  },
                                  model: {
                                    value:
                                      _vm.paginationSettings[idx].currentPage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.paginationSettings[idx],
                                        "currentPage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "paginationSettings[idx].currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        }),
        0
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { margin: "10px 0px" } }, [
      _c("span", [_vm._v("No resource files have been uploaded yet..")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dc19a49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dc19a49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentResourceUploads.vue
// module id = null
// module chunks = 